var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.materials,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-plus",
                    label: _vm.$t("new"),
                    disable: !_vm.manageWebcasts
                  },
                  on: {
                    click: function($event) {
                      return _vm.showMaterialModal(0)
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.id) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "title", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.title) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "extension", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.extension) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "size", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.size) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "primary",
                            icon: "far fa-pencil-alt",
                            disable: !_vm.manageWebcasts
                          },
                          on: {
                            click: function($event) {
                              return _vm.showMaterialModal(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "negative",
                            icon: "far fa-trash-alt",
                            disable: !_vm.manageWebcasts
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmRemove(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("delete_tooltip")) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_webcasts" })
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.clearMaterialModal()
            }
          },
          model: {
            value: _vm.material_modal,
            callback: function($$v) {
              _vm.material_modal = $$v
            },
            expression: "material_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.material_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("support_material")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("title"),
                          error: _vm.$v.title.$error
                        },
                        on: { input: _vm.$v.title.$touch },
                        model: {
                          value: _vm.title,
                          callback: function($$v) {
                            _vm.title = $$v
                          },
                          expression: "title"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("status")))
                      ]),
                      _c("q-btn-toggle", {
                        attrs: {
                          "toggle-color": _vm.getColorButtonStatus,
                          options: _vm.statuses
                        },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-6" },
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("file")))
                      ]),
                      _c("uploader", {
                        attrs: {
                          content_type: "",
                          multiple: false,
                          cropper: false,
                          error: _vm.$v.file_url.$error
                        },
                        on: {
                          fileUploaded: _vm.fileUploaded,
                          input: _vm.$v.file_url.$touch
                        }
                      }),
                      _vm.file_url
                        ? _c(
                            "p",
                            { staticClass: "q-mt-md file-url" },
                            [
                              _c("q-icon", {
                                attrs: {
                                  name: "fal fa-check",
                                  color: "positive"
                                }
                              }),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.file_complete_url,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$truncateLink(_vm.file_url))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "far fa-block"
                          },
                          on: {
                            click: function($event) {
                              _vm.material_modal = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("save"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveMaterial()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.removeMaterial()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeMaterial()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }